export default function DivorceRelocationSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Life Changes Require Quick Land Sales
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Divorce, job relocation, medical emergencies, and other life transitions often require liquidating assets quickly. Land is typically the hardest asset to sell fast through traditional methods, but it doesn't have to be.
            </p>

            <div className="space-y-6 mb-8">
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900 flex items-center">
                  <i className="ri-heart-line text-teal-600 mr-3 text-2xl"></i>
                  Divorce Settlements
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  When dividing marital assets, land can be a major sticking point. Neither party wants to keep paying taxes and maintenance on property they don't want, but selling through a realtor takes months. A cash sale provides immediate liquidity that can be divided according to your divorce decree, allowing both parties to move forward quickly.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900 flex items-center">
                  <i className="ri-map-pin-line text-teal-600 mr-3 text-2xl"></i>
                  Job Relocation
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Moving to another state or country for work? You don't want to manage vacant land from 1,000 miles away. Selling for cash before you relocate eliminates the hassle of long-distance property management, tax payments, and the uncertainty of finding a buyer after you've moved.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900 flex items-center">
                  <i className="ri-hospital-line text-teal-600 mr-3 text-2xl"></i>
                  Medical Expenses
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Unexpected medical bills can devastate family finances. If you own land that's sitting vacant, converting it to cash can provide the funds you need for treatment, medications, or long-term care. We can close quickly to get you the money when you need it most.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-3 text-gray-900 flex items-center">
                  <i className="ri-building-line text-teal-600 mr-3 text-2xl"></i>
                  Business Needs
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Need capital to start or save a business? Land equity can provide that capital, but only if you can access it quickly. Traditional sales take too long when you need funds for payroll, inventory, or business opportunities. Our cash purchases give you immediate access to your land's value.
                </p>
              </div>
            </div>

            <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-lg">
              <p className="text-gray-900 font-semibold mb-2">
                <i className="ri-heart-fill text-teal-600 mr-2"></i>
                We Understand Life Happens
              </p>
              <p className="text-gray-700 leading-relaxed">
                At TRex RE LLC, we've worked with hundreds of sellers facing difficult life circumstances. We approach every situation with empathy and professionalism, providing fair offers and flexible closing timelines that work for your situation.
              </p>
            </div>
          </div>

          <div className="w-full h-full min-h-96 rounded-lg overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/25a57338e42fcd650d8e16a374daf8fd.jpg"
              alt="Selling land during divorce or relocation"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
